// extracted by mini-css-extract-plugin
export default {"title":"DeleteElementModal_title__ugWy2","btnGroup":"DeleteElementModal_btnGroup__yVVCr","btn":"DeleteElementModal_btn__h+LPF"};